import { render } from "./OrderTabOrderInfo.vue?vue&type=template&id=74baeff5&scoped=true"
import script from "./OrderTabOrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderTabOrderInfo.vue?vue&type=script&lang=js"

import "./OrderTabOrderInfo.vue?vue&type=style&index=0&id=74baeff5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74baeff5"]])

export default __exports__